<div class="relatorio-painel-risco container-fluid">
  <h3><Strong>Relatório - Painel de Risco</Strong></h3>
  <mat-card>
    <mat-card-header class="header-padrao">
      <mat-card-title>
        <form class="filtros-header" [formGroup]="filterForm">
          <div class="d-flex justify-content-between">
            <div class="flex-grow-1">
              <div class="d-flex flex-row flex-wrap">
                <mat-form-field>
                  <mat-label>(Data de entrada) de:</mat-label>
                  <input matInput autocomplete="off" maskDate [matDatepicker]="dataInicio" formControlName="fromDate">
                  <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                  <mat-datepicker #dataInicio></mat-datepicker>
                </mat-form-field>
              
                <mat-form-field>
                  <mat-label>(Data de entrada) Até:</mat-label>
                  <input matInput autocomplete="off" maskDate [matDatepicker]="dataFim" formControlName="toDate">
                  <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
                  <mat-datepicker #dataFim></mat-datepicker>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Filial Origem:</mat-label>
                  <mat-select [(ngModel)]="filial" formControlName="filialFormControl">
                      <mat-option value="">Todos</mat-option>
                      <mat-option *ngFor="let f of filiais" [value]="f.filialID">
                        {{f.descricao}}
                      </mat-option>
                  </mat-select>
                </mat-form-field>

                <app-cliente-autocomplete [form]="filterForm" (clienteIdOutput)="reciverFeedback($event)">
                </app-cliente-autocomplete>

                <mat-form-field>
                  <mat-label>Produto:</mat-label>
                  <mat-select [(ngModel)]="produto" formControlName="produtosFormControl">
                    <mat-option value="">Todos</mat-option>
                    <mat-option *ngFor="let p of produtos" [value]="p.produtoID">
                      {{p.descricao}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <button mat-icon-button
                  type="button"
                  [ngClass]="{ disabled: isLoading }"
                  (click)="isLoading ? null : paging.index = 0; clearFields()">
                    <i class="fas fa-eraser eraser-button" matTooltip="Limpar Campos"></i>
                  &nbsp;&nbsp;
                </button>
                <button mat-icon-button
                  type="submit"
                  [ngClass]="{ disabled: isLoading }"
                  [disabled]="filterForm.invalid"
                  (click)="isLoading ? null : selecionarRelatorioNRTConsultarEtapas()">
                    <i class="fas fa-search search-button cursor-pointer-icon" matTooltip="Pesquisar"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center buttons-agrupadores" *ngIf="totalizadores">
            <ngx-charts-number-card #cards scheme="cool"
              [results]="indicadores"
              cardColor="#fefefe"
              (select)="toggleIndicador($event)">
            </ngx-charts-number-card>
          </div>
        </form>
      </mat-card-title>
    </mat-card-header>
    <mat-progress-bar [hidden]="!isLoading" color="primary" mode="indeterminate"></mat-progress-bar>

    <app-painel-controle-risco-grid-detalhes #gridDetalhes
      [filters]="gridFilters"
      [hidden]="!gridFilters"></app-painel-controle-risco-grid-detalhes>
  </mat-card>
</div>